
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import SlimButton from './slim-button'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "slimbutton"
    }}>{`SlimButton`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Buttons`}</p>
    <hr />
    <h2 {...{
      "id": "slim-button"
    }}>{`Slim button`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For actions where space is limited, or to resolve conflicting priorities between nearby buttons. Do not use for principle actions.`}</p>
    <Playground __position={1} __code={'<SlimButton>Slim button</SlimButton>\n<SlimButton disabled>Slim button</SlimButton>\n<SlimButton icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</SlimButton>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SlimButton
    }} style={{
      paddingRight: '50%',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <SlimButton mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton disabled mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton icon mdxType="SlimButton">
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
       <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
     </svg>
  </SlimButton>
    </Playground>
    <hr />
    <h2 {...{
      "id": "slim-button-inverse"
    }}>{`Slim button (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For actions where space is limited, or to resolve conflicting priorities between nearby buttons. Do not use for principle actions.`}</p>
    <Playground __position={3} __code={'<SlimButton inverse>Slim button</SlimButton>\n<SlimButton inverse disabled>\n  Slim button\n</SlimButton>\n<SlimButton inverse icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</SlimButton>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SlimButton
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em 50% 2em 2em',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <SlimButton inverse mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton inverse disabled mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton inverse icon mdxType="SlimButton">
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
       <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
     </svg>
  </SlimButton>
    </Playground>
    <hr />
    <h2 {...{
      "id": "slim-button-secondary"
    }}>{`Slim button (secondary)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For secondary actions where space is limited, and for additional options adjacent to a slim primary button.`}</p>
    <Playground __position={5} __code={'<SlimButton secondary>Slim button</SlimButton>\n<SlimButton secondary disabled>\n  Slim button\n</SlimButton>\n<SlimButton secondary icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</SlimButton>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SlimButton
    }} style={{
      paddingRight: '50%',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <SlimButton secondary mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton secondary disabled mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton secondary icon mdxType="SlimButton">
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
       <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
     </svg>
  </SlimButton>
    </Playground>
    <hr />
    <h2 {...{
      "id": "slim-button-inverse-secondary"
    }}>{`Slim button (inverse, secondary)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For secondary actions where space is limited, and for additional options adjacent to a slim primary button.`}</p>
    <Playground __position={7} __code={'<SlimButton inverse secondary>\n  Slim button\n</SlimButton>\n<SlimButton inverse secondary disabled>\n  Slim button\n</SlimButton>\n<SlimButton inverse secondary icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</SlimButton>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SlimButton
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em 50% 2em 2em',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <SlimButton inverse secondary mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton inverse secondary disabled mdxType="SlimButton">Slim button</SlimButton>
  <SlimButton inverse secondary icon mdxType="SlimButton">
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
       <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
     </svg>
  </SlimButton>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={SlimButton} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;